import React from "react";
import { Avatar, Tooltip } from "antd";
import { UserOutlined, LogoutOutlined } from "@ant-design/icons";
import Cookies from "js-cookie";
// import "../ClientsNavbar/ClientNavbar.css";
import "../../GlobalCss/SPF/ClientNavbar.css";
import { Link } from "react-router-dom";
const ClientNavbar = () => {
  const firstName = Cookies.get("first_name");
  const onClickLogout = () => {
    Cookies.remove("jwt_token");
    Cookies.remove("UserLogin");
    Cookies.remove("first_name");
    Cookies.remove("last_name");
    Cookies.remove("Role");
    Cookies.remove("Date");
  };

  return (
    <div>
      <div className="nav-elements">
        <Avatar icon={<UserOutlined />} />
        <p className="client-user"> {firstName} </p>
        <div className="header-nav">
          <div className="head-text" style={{ paddingRight: 10 }}>
            <Link
              to={{ pathname: "/", state: { logoutMsg: "yes" } }}
              style={{ textDecoration: "none" }}
              onClick={onClickLogout}
              className="logout-link"
            >
              <Tooltip title="Logout">
                <LogoutOutlined
                  style={{ fontSize: 23, color: "white", marginLeft: "10px" }}
                />
              </Tooltip>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ClientNavbar;
